module.exports = __webpack_public_path__ + "img/slideImgAct.febb6143.png";